export class PermisoFilter {
   public nombre: string = "";
   public codigo: string = "";
   public activo: number;
}
